export const environment = {
  production: false,
  demo: true,
  name: 'demo',

  apiUrl: 'http://api.victorylib.test/api/v1',
  apiBaseUrl: 'http://api.victorylib.test',

  features: {
    enableAnalytics: false,
    enableErrorReporting: false,
    enableDebugMode: true,
    enableMockData: true,
  },

  logging: {
    level: 'info',
    enableConsoleLogging: true,
    enableRemoteLogging: false,
  },

  app: {
    version: '1.0.0-demo',
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'es', 'fr'],
    sessionTimeout: 60 * 60 * 1000,
  },

  storage: {
    prefix: 'victory_lib_demo_',
    authTokenKey: 'auth_token',
    userKey: 'user',
    settingsKey: 'settings',
  },

  demoConfig: {
    autoLogin: true,
    login: {
      email: 'demo@victorylib.com',
      password: 'password123',
      rememberMe: true,
      autoSubmit: true,
      seedUserOnLogin: true,
      allowAnyCredentials: false,
    },
    demoUser: {
      id: 'demo-user-001',
      name: 'Miriam Stone',
      email: 'demo@victorylib.com',
      user_id: 'demo-user-001',
    },

    apiDelay: 500,

    errorRate: 0,
    errorStatusCodes: [401, 404, 500],
  },
};
